export default "__VITE_ASSET__af5fe796__"